import React, {useState} from 'react';
import trypiContext from "./trypiContext";
import Api from "../api/Api";

const TrypiProvider = ({children}) => {
    const [pisaasFetchEnvInfoByInstance, setPisaasFetchEnvInfoByInstance] = useState({loading: true, data: {}});

    const updatePisaasFetchEnvInfoByInstance = (domain, region) => {
        const api = Api();
        api.pisaasFetchEnvInfoByInstance(
            (data) => {setPisaasFetchEnvInfoByInstance({loading: false, data: data})},
            (error) => {console.log(error)},
            domain, region);
    };

    return (
        <trypiContext.Provider value={{pisaasFetchEnvInfoByInstance, updatePisaasFetchEnvInfoByInstance}}>
            {children}
        </trypiContext.Provider>
    );
}

export default TrypiProvider;